import * as React from "react";
import {
  Linking,
  StyleSheet,
  View,
  Switch,
  TouchableOpacity,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { ScrollView } from "react-native-gesture-handler";
import { useContext } from "react";
import SettingToggle from "./SettingsImpl/SettingToggle.js";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";
import { AvailableUserSettingsContext } from "../context/AvailableUserSettingsProvider.js";
import { backendUrl } from "../constants/Environment.js";
import { MonoText } from "../components/StyledText.js";
import { useWindowDimensions } from "react-native";
import { AppDataContext } from "../context/AppDataProvider.js";
import SocialIconFacebook from "./MiscImpl/SocialIconFacebook";
import SocialIconInstagram from "./MiscImpl/SocialIconInstagram";
import SocialIconYoutube from "./MiscImpl/SocialIconYoutube";
import SocialIconTwitter from "./MiscImpl/SocialIconTwitter";
import * as SecureStore from "expo-secure-store";
import AsyncStorage from "@react-native-async-storage/async-storage";

export default function NavbarMobileScreen({
  navigation,
  route,
  handleLogout,
  userId,
  authToken,
  myUserSettings,
}) {
  const {
    categories,
    setLoggedIn,
    isLoggedIn,
    colors,
    isDarkMode,
    setDarkMode,
  } = useContext(AppDataContext);
  const { globalSettings } = useContext(GlobalSettingsContext);
  const { availableSettings } = useContext(AvailableUserSettingsContext);

  const [toggleMuteSounds, setToggleMuteSounds] = React.useState(false);

  /**
   * For viewing more categories
   */
  const [expandDropdown, setExpandDropdown] = React.useState(false);
  const [expandDropdownAccount, setExpandDropdownAccount] =
    React.useState(false);

  const darkThemeDescription = "App Dark Mode";
  const muteSoundsDescription = "Mute Sounds";

  const window = useWindowDimensions();

  const container = {
    flex: 1,
    backgroundColor: colors.background,
  };

  const contentContainer = {
    paddingTop: 15,
  };

  const darkModeLabel = () => {
    if (!availableSettings) {
      return "Loading...";
    }
    var result = availableSettings.find(
      (a) => a && a.description && a.description === darkThemeDescription
    );
    if (!result) {
      /**
       * If no setting is found, resort to the globalsettings thing
       */
      return "App Dark Mode";
    }
    return result.description;
  };

  const darkModeValue = () => {
    if (myUserSettings) {
      var result = myUserSettings.find(
        (a) => a.setting && a.setting.description === darkThemeDescription
      );
      if (!result) {
        return false;
      }
      return result.rawValue === "dark";
    }
    return false;
  };

  const muteSoundsValue = () => {
    if (myUserSettings) {
      var result = myUserSettings.find(
        (a) => a.setting && a.setting.description === muteSoundsDescription
      );
      if (!result) {
        return false;
      }
      return result.rawValue === "true";
    }
    return false;
  };

  const toggleScheme = () => {
    /*
     * setScheme will change the state of the context
     * thus will cause childrens inside the context provider to re-render
     * with the new color scheme
     */
    setDarkMode((a) => !a);

    if (isLoggedIn || userId > -1) {
      /**
       * Update the backend for the setting chosen by the user.
       */
      fetch(`${backendUrl}/user-settings/edit/${userId}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
        body: JSON.stringify({
          userId: userId,
          settingDescription: darkThemeDescription,
          value: isDarkMode,
        }),
      })
        .then((response) => {
          if (response) {
            response.json().then((response) => {});
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const toggleMute = () => {
    var next = true;

    var val = muteSoundsValue();
    if (val === false) {
      next = true;
    } else {
      next = false;
    }

    setToggleMuteSounds(next);

    /**
     * Update the backend for the setting chosen by the user.
     */
    fetch(`${backendUrl}/user-settings/edit/${userId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken,
      },
      body: JSON.stringify({
        userId: userId,
        settingDescription: muteSoundsDescription,
        value: next,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response) {
          var result = myUserSettings.find(
            (a) => a.setting && a.setting.description === muteSoundsDescription
          );
          if (!result) {
            /**
             * Add a local value
             */
            myUserSettings.push({
              rawValue: next.toString(),
              userId: userId,
              setting: {
                description: muteSoundsDescription,
              },
            });
            return false;
          } else {
            result.rawValue = next.toString();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  React.useEffect(() => {
    setToggleMuteSounds(muteSoundsValue());
  }, []);

  if (!availableSettings) {
    return <></>;
  }

  var styleDynamic = StyleSheet.create({
    container: {
      backgroundColor: colors.background,
      textShadowColor: "#585858",
      textShadowOffset: { width: 5, height: 5 },
      textShadowRadius: 10,
    },
    nextContainer: {
      marginBottom: 32,
      marginTop: 0,
      alignItems: window.width > 800 ? "center" : "stretch",
      minHeight: 600,
      backgroundColor: colors.background,
      flex: 1,
      paddingTop: 30,
      flexGrow: 1,
    },
  });

  return (
    <ScrollView
      style={{
        backgroundColor: colors.background,
        flex: 1,
      }}
    >
      <TouchableOpacity style={styleDynamic.container} activeOpacity={1}>
        <TouchableOpacity
          onPress={() => {
            navigation.goBack();
          }}
        >
          <Ionicons name="md-close" size={32} color={colors.vectorColor} />
        </TouchableOpacity>
        <View style={styleDynamic.nextContainer}>
          <ScrollView
            style={container}
            contentContainerStyle={contentContainer}
          >
            <OptionButton
              icon="ios-arrow-down-outline"
              label="Categories"
              isExpandable
              action={() => {
                setExpandDropdown((a) => !a);
              }}
              onPress={() => {}}
            />
            {expandDropdown && (
              <View>
                {categories.map((a, b) => {
                  return (
                    <OptionButton
                      icon="ios-arrow-down-outline"
                      label={a.category_name}
                      subOption
                      action={() => {
                        setExpandDropdown((a) => !a);
                        navigation.navigate("ArticleList", {
                          showCategoryName: a.category_name,
                        });
                      }}
                      onPress={() => {}}
                    />
                  );
                })}
              </View>
            )}
            <OptionButton
              icon="ios-arrow-down-outline"
              label="Account"
              isExpandable
              action={() => {
                setExpandDropdownAccount((a) => !a);
              }}
              onPress={() => {}}
            />
            {expandDropdownAccount && (
              <View>
                <React.Fragment>
                  {isLoggedIn ? (
                    <React.Fragment>
                      <OptionButton
                        icon="ios-arrow-down-outline"
                        label={"Change Password"}
                        subOption
                        action={() => {
                          setExpandDropdownAccount((a) => !a);
                          navigation.navigate("ChangePassword");
                        }}
                        onPress={() => {}}
                      />
                      <OptionButton
                        icon="exit-outline"
                        label="Sign out"
                        onPress={() => {}}
                        subOption
                        action={async () => {
                          try {
                            var isMobile = await SecureStore.isAvailableAsync();
                            if (!isMobile) {
                              AsyncStorage.removeItem("authentication_data");
                            } else {
                              SecureStore.deleteItemAsync(
                                "authentication_data"
                              );
                            }
                          } catch (exception) {
                            console.log(exception);
                          }
                          setLoggedIn(false);
                        }}
                        isLastOption
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {" "}
                      <OptionButton
                        icon="ios-arrow-down-outline"
                        label={"Login"}
                        subOption
                        action={() => {
                          navigation.navigate("Login");
                        }}
                        onPress={() => {}}
                      />
                      <OptionButton
                        icon="ios-arrow-down-outline"
                        label={"Sign up"}
                        subOption
                        action={() => {
                          navigation.navigate("Register");
                        }}
                        onPress={() => {}}
                      />
                    </React.Fragment>
                  )}
                </React.Fragment>
              </View>
            )}
            <OptionButton
              description={darkThemeDescription}
              icon="contrast-outline"
              label={darkModeLabel()}
              isToggle={true}
              action={toggleScheme}
              value={isDarkMode}
            ></OptionButton>
            <OptionButton
              icon="newspaper-outline"
              label="Subscribe Newsletter"
              onPress={() => navigation.navigate("SubscribeNewsletter")}
            />
            <OptionButton
              icon="document-text-outline"
              label="Privacy Policy"
              onPress={() =>
                navigation.navigate("Information", { data: "privacy policy" })
              }
            />
            <OptionButton
              icon="people-outline"
              label="About Us"
              onPress={() =>
                navigation.navigate("Information", { data: "about us" })
              }
            />
            <OptionButton
              icon="md-football-outline"
              label="Cookie Policy"
              onPress={() =>
                navigation.navigate("Information", { data: "cookie policy" })
              }
            />
            <OptionButton
              icon="shield-checkmark-outline"
              label="Terms/Conditions"
              onPress={() =>
                navigation.navigate("Information", {
                  data: "terms and conditions",
                })
              }
            />
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                marginBottom: 12,
                marginLeft: 12,
                marginRight: 12,
                marginTop: 12,
              }}
            >
              <TouchableOpacity
                style={{
                  paddingLeft: 12,
                }}
                onPress={() =>
                  Linking.openURL(
                    "https://" +
                      String(
                        globalSettings?.find(
                          (a) => a.description.toLowerCase() === "facebook link"
                        )?.value
                      )
                  )
                }
              >
                <SocialIconFacebook />
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  paddingLeft: 12,
                }}
                onPress={() =>
                  Linking.openURL(
                    "https://" +
                      String(
                        globalSettings?.find(
                          (a) =>
                            a.description.toLowerCase() === "instagram link"
                        )?.value
                      )
                  )
                }
              >
                <SocialIconInstagram />
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  paddingLeft: 12,
                }}
                onPress={() =>
                  Linking.openURL(
                    "https://" +
                      String(
                        globalSettings?.find(
                          (a) => a.description.toLowerCase() === "youtube link"
                        )?.value
                      )
                  )
                }
              >
                <SocialIconYoutube />
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  paddingLeft: 12,
                }}
                onPress={() =>
                  Linking.openURL(
                    "https://" +
                      String(
                        globalSettings?.find(
                          (a) => a.description.toLowerCase() === "twitter link"
                        )?.value
                      )
                  )
                }
              >
                <SocialIconTwitter />
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
      </TouchableOpacity>
    </ScrollView>
  );
}

function OptionButton({
  icon,
  label,
  onPress,
  isLastOption,
  isToggle,
  isExpandable,
  action,
  value,
  subOption,
}) {
  const { colors } = useContext(AppDataContext);

  const styles = StyleSheet.create({
    optionIconContainer: {
      marginRight: 12,
    },
    option: {
      backgroundColor: colors.secondary,
      paddingHorizontal: 15,
      paddingVertical: 15,
      borderWidth: StyleSheet.hairlineWidth,
      borderBottomWidth: 0,
      borderColor: colors.secondaryBorderColour,
    },
    subOption: {
      backgroundColor: colors.tertiary,
      paddingHorizontal: 15,
      paddingVertical: 15,
      paddingLeft: 32,
      // borderWidth: StyleSheet.hairlineWidth,
      borderBottomWidth: 0,
      // borderColor: colors.secondaryBorderColour,
    },
    lastOption: {
      borderBottomWidth: StyleSheet.hairlineWidth,
    },
    optionText: {
      fontSize: 15,
      alignSelf: "flex-start",
      marginTop: 1,
      color: colors.text,
    },
  });
  if (isExpandable) {
    /**
     * We only need one expandable option
     */
    return (
      <TouchableOpacity
        style={[styles.option, isLastOption && styles.lastOption]}
        onPress={(a) => action()}
      >
        <View style={{ flexDirection: "row" }}>
          <View style={styles.optionTextContainer}>
            <MonoText style={styles.optionText}>{label}</MonoText>
          </View>
          <View
            style={{
              flex: 1,
              alignItems: "flex-end",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignSelf: "flex-end",
            }}
          >
            <View style={styles.optionIconContainer}>
              <Ionicons name={icon} size={22} color={colors.vectorColor} />
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  } else if (subOption) {
    /**
     * This is for the sub-options
     */
    return (
      <TouchableOpacity style={[styles.subOption]} onPress={(a) => action()}>
        <View style={{ flexDirection: "row" }}>
          <View style={styles.optionTextContainer}>
            <MonoText style={styles.optionText}>{label}</MonoText>
          </View>
          <View
            style={{
              flex: 1,
              alignItems: "flex-end",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignSelf: "flex-end",
            }}
          ></View>
        </View>
      </TouchableOpacity>
    );
  }
  if (isToggle) {
    return (
      <TouchableOpacity
        style={[styles.option, isLastOption && styles.lastOption]}
        onPress={(a) => action()}
      >
        <View style={{ flexDirection: "row" }}>
          <View style={styles.optionTextContainer}>
            <MonoText style={styles.optionText}>{label}</MonoText>
          </View>
          {isToggle && (
            <View
              style={{
                flex: 1,
                alignItems: "flex-end",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignSelf: "flex-end",
              }}
            >
              <Switch
                trackColor={{ false: "#767577", true: "#81b0ff" }}
                thumbColor={value ? "#f5dd4b" : "#f4f3f4"}
                ios_backgroundColor="#3e3e3e"
                onValueChange={() => action()}
                value={value}
              />
            </View>
          )}
        </View>
      </TouchableOpacity>
    );
  }
  return (
    <TouchableOpacity
      style={[styles.option, isLastOption && styles.lastOption]}
      onPress={onPress}
    >
      <View style={{ flexDirection: "row" }}>
        <View style={styles.optionIconContainer}>
          <Ionicons name={icon} size={22} color={colors.vectorColor} />
        </View>
        <View style={styles.optionTextContainer}>
          <MonoText style={styles.optionText}>{label}</MonoText>
        </View>
        {isToggle && (
          <View
            style={{
              flex: 1,
              alignItems: "flex-end",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignSelf: "flex-end",
            }}
          >
            <SettingToggle />
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
}
